import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import '../styles/WhatsAppFloat.css';

const WhatsAppFloat = () => {
    return (
        <a 
            href="https://wa.me/919893020271" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="whatsapp-float"
            aria-label="Chat with us on WhatsApp"
        >
            <FaWhatsapp />
            <span>Chat with us</span>
        </a>
    );
};

export default WhatsAppFloat;
